import { CodeOutlined } from "@ant-design/icons";
import { PARAMETER_COLORS, ParameterCategory } from "components/CC/UI/ParameterPicker/ParameterPicker";

export const PREDEFINED_CUSTOM_KEYS = [
    "endpoint",
    "endpoint_auth",
    "token",
    "token_secondary",
    "token_sign",
    "username",
    "password",
    "partner_id",
    "price",
    "redirect_url",
] as const;

const CUSTOM_PREFIX_PLACEHOLDER_ID = "custom_";

/**
 * Static "Keys" picker category for the Custom Key form's Key field. Unlike the CC diagram's Keys
 * category (built from the integration's already-saved custom fields), this is a fixed suggestion
 * list — the same list every integration starts from. `excludeKeys` hides predefined keys the
 * integration already has a custom field for, so the picker can't suggest a duplicate — "custom_"
 * always stays since it isn't a single concrete key.
 */
export const createPredefinedKeysCategory = (
    t: (key: string) => string,
    excludeKeys: string[] = []
): ParameterCategory => {
    const availableKeys = PREDEFINED_CUSTOM_KEYS.filter((key) => !excludeKeys.includes(key));

    return {
        id: "keys",
        name: t("parameter_picker.categories.keys"),
        icon: (
            <span
                className="inline-flex items-center justify-center w-5 h-5 rounded"
                style={{ backgroundColor: PARAMETER_COLORS.keys }}
            >
                <CodeOutlined style={{ color: "#ffffff", fontSize: 12 }} />
            </span>
        ),
        type: "keys",
        count: availableKeys.length + 1,
        items: [
            ...availableKeys.map((key) => ({ id: key, name: key, paramType: "keys" as const })),
            {
                id: CUSTOM_PREFIX_PLACEHOLDER_ID,
                name: CUSTOM_PREFIX_PLACEHOLDER_ID,
                paramType: "keys" as const,
                insertAsRawText: true,
                matchByPrefix: true,
            },
        ],
    };
};
